module.exports = __webpack_public_path__ + "static/slide-3-556a87d79ca7f3fa6dd716cf2825deaa.jpg";